import React from "react";
import { Helmet } from "react-helmet-async";
import { Stack, Box, TextField } from "@mui/material";

import SaveIcon from "@mui/icons-material/Save";

import useApiKey from "../../../hooks/super/useApiKey";
import useAuth from "../../../hooks/useAuth";

import OtxApiKeyHistoryList from "./component/T_OtxApiKeyHistory";
import { CollapseAlert } from "../../../components/pages/common/styled";
import { UserType } from "../../../utils/constants";

import PageHeader from "../../../components/pages/_new/super/common/PageHeader";
import PrimaryButton from "../../../components/pages/_new/super/common/PrimaryButton";
import {
  TOKENS,
  SectionCard,
} from "../../../components/pages/_new/super/design";

function SAOtxApiKey() {
  const { getOtxApiKeyHistory, apiSize, insertOtxApiKey, errMsg, setErr } = useApiKey();
  const { isAuthenticated, adminUserType } = useAuth();

  const otxApikeyRef = React.useRef(null);
  const [otxApiKeyValue, setOtxApiKeyValue] = React.useState("");
  const saveOtxApiKey = () => {
    if (!otxApiKeyValue) {
      otxApikeyRef.current?.focus();
      return;
    }
    insertOtxApiKey(otxApiKeyValue);
    setOtxApiKeyValue("");
  };
  const changeOtxApiKey = (e) => setOtxApiKeyValue(e.target.value);

  React.useEffect(() => {
    if (isAuthenticated) getOtxApiKeyHistory(apiSize, 0);
    return () => setErr(null);
  }, [isAuthenticated, apiSize, getOtxApiKeyHistory, setErr]);

  const [errOpen, setErrOpen] = React.useState(false);
  React.useEffect(() => {
    if (errMsg) setErrOpen(true);
  }, [errMsg]);

  const isSuper = UserType.SUPER_ADMIN === adminUserType;

  return (
    <React.Fragment>
      <Helmet title="SA OTX API Key" />
      <PageHeader title="OTX API Key" description="AlienVault OTX threat intelligence key used by the WAF" />
      <Box sx={{ mb: 3 }}>
        <CollapseAlert errOpen={errOpen} setErrOpen={setErrOpen} setErr={setErr} errMsg={errMsg} />
      </Box>

      <Stack spacing={2}>
        <SectionCard title="Current API key" description="Rotate by entering a new key and clicking Save">
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ maxWidth: 720 }}>
            <TextField
              fullWidth
              size="small"
              placeholder="OTX API key"
              required
              value={otxApiKeyValue}
              onChange={changeOtxApiKey}
              inputRef={otxApikeyRef}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: `${TOKENS.radiusXs}px`,
                  background: TOKENS.bgSurface,
                },
              }}
            />
            <PrimaryButton
              onClick={saveOtxApiKey}
              startIcon={<SaveIcon style={{ width: 18, height: 18 }} />}
              disabled={!isSuper}
            >
              Save
            </PrimaryButton>
          </Stack>
        </SectionCard>

        <SectionCard title="Recent API keys" description="History of OTX key rotations">
          <OtxApiKeyHistoryList />
        </SectionCard>
      </Stack>
    </React.Fragment>
  );
}
export default SAOtxApiKey;
